module.exports = __webpack_public_path__ + "img/1577233873.a734589b.jpg";